import React from "react";
import "../TheWinners.scss";

import empty from '../assets/img/empty.png';

const WinnersContentEmpty = ({ title = 'Приз еще ищет победителя 😉', suppressImage }) => {
  return (
    <div className="winners__content__empty">
      <div className="winners__content__empty-title">
        <p>{ title }</p>
      </div>

      {
        !suppressImage && 
        (<div className="winners__content__empty-image">
          <img src={empty} alt="Приз еще ищет победителя" />
        </div>)
      }
    </div>
  );
};

export default WinnersContentEmpty;
